import { notification } from 'antd';

export default {
  openNotification(title: string, message: string) {
    notification.open({
      message: title,
      description: message,
    });
  },
  showError(message: string, options?: any) {
    notification.error({ ...options, message });
  },
  showInfo(message: string, options?: any) {
    notification.info({ ...options, message });
  },
  showSuccess(message: string, options?: any) {
    notification.success({ ...options, message });
  },
};
